// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2l-e";
export var animationRelative = "_2l-d";
export var backdropBlur = "_2l-0";
export var detailLabelCell = "_2l-q";
export var detailTable = "_2l-p";
export var detailValueCell = "_2l-r";
export var documentTypeIcon = "_2l-y";
export var documentTypeOption = "_2l-x";
export var dropdownMatchDatePicker = "_2l-3";
export var evidenceCardContent = "_2l-w";
export var gorgiasTicketCard = "_2l-s";
export var iconTertiary = "_2l-z";
export var integrationCard = "_2l-1";
export var integrationLogoBox = "_2l-2";
export var mainColumnSticky = "_2l-v";
export var maxWidthContainer = "_2l-t";
export var modalContentBody = "_2l-a";
export var modalHeaderImage = "_2l-5";
export var modalImageLabel = "_2l-7";
export var modalImageOverlay = "_2l-6";
export var modalImageSubtitle = "_2l-9";
export var modalImageTitle = "_2l-8";
export var modalImageWrapper = "_2l-4";
export var modalStickyFooter = "_2l-b";
export var sidebarColumn = "_2l-u";
export var timelineLine = "_2l-m";
export var timelineLineBlack = "_2l-o _2l-m";
export var timelineLineGray = "_2l-n _2l-m";
export var timelineLineHeight = "_2l-l";
export var tlDotActivate = "_2l-i";
export var tlDotActivateAnim = "_2l-h";
export var tlDotHide = "_2l-g";
export var tlDotHideAnim = "_2l-f";
export var tlLineActivate = "_2l-k";
export var tlLineActivateAnim = "_2l-j";
export var uploadedFileRow = "_2l-c";